import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Route,
  RouterStateSnapshot,
} from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { VehicleResponse } from '../../shared/services/api-client';
import { vehicleResolverFactory } from './resolvers/vehicle.resolver';

export const vehicleRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Vehicle.List.Title'),
    loadComponent: () =>
      import('./components/vehicle-list/vehicle-list.component').then(
        (m) => m.VehicleListComponent,
      ),
  },
  {
    path: ':vehicleId',
    children: [
      {
        path: 'detail',
        resolve: {
          vehicle: (
            route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot,
          ): ReturnType<ResolveFn<VehicleResponse | undefined>> => {
            const vehicleIdRaw = route.paramMap.get('vehicleId');
            const vehicleId = Number(vehicleIdRaw);

            const vehicleResolver = vehicleResolverFactory(vehicleId);
            return vehicleResolver(route, state);
          },
        },
        loadComponent: () =>
          import('./components/vehicle-detail/vehicle.detail.component').then(
            (m) => m.VehicleDetailComponent,
          ),
      },
    ],
  },
];
